import React from "react";
import { Modal, Box, Typography, Fade } from "@mui/material";
import CustomButton from "../../../shared/CustomButton";
import { useDispatch } from "react-redux";
import { CheckTheStatus, LoadSubscribers } from "../../state/alertActions";
const Modalstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: "6px",
  padding: "24px 24px 0 24px",
  display: "flex",
  flexDirection: "column",
};
const ActivateCustomers = ({
  open,
  onClose,
  rows,
  error,
  success,
  ActiveUser,
  handleUnselectAll,
}) => {
  const dispatch = useDispatch();

  const saveChanges = (rows) => {
    if (open.Type === "ACTIVE") {
      let data = {
        status: ActiveUser,
        customerIds: rows.map((element) => element.id),
      };
      dispatch(CheckTheStatus(data, success, error)).then(() => {
        dispatch(
          LoadSubscribers(
            {
              pageNumber: 1,
              pageSize: 10,
            },
            error
          )
        );
        onClose({ status: false, Type: "" });
        handleUnselectAll();
      });
    } else {
      let data = {
        status: "INACTIVE",
        customerIds: rows.map((element) => element.id),
      };
      dispatch(CheckTheStatus(data, success, error)).then(() => {
        dispatch(
          LoadSubscribers(
            {
              pageNumber: 1,
              pageSize: 10,
            },
            error
          )
        );
        onClose({ status: false, Type: "" });
        handleUnselectAll();
      });
    }
  };

  const returnWarning = () => {
    if (open.Type === "ACTIVE") {
      const checkGenerateFlag = rows
        .map((row) => row.status)
        .includes("INACTIVE");
      const isBelowThreshold = (currentValue) => currentValue === "INACTIVE";

      const checkGenerateFlagForDeactive = rows
        .map((row) => row.status)
        .every(isBelowThreshold);
      if (checkGenerateFlagForDeactive) {
        switch (checkGenerateFlagForDeactive) {
          case true:
            return "You are about to activate an inactive customer, would you like to proceed?";
          default:
            break;
        }
      } else {
        switch (checkGenerateFlag) {
          case true:
            return "One or more Customers you are trying to activate are already activated, proceed with activation?";

          case false:
            return "The customer you are trying to activate is already activated, proceed with activation?";
          default:
            break;
        }
      }
    } else {
      const checkGenerateFlag = rows
        .map((row) => row.status)
        .includes(ActiveUser);
      const isBelowThreshold = (currentValue) => currentValue === ActiveUser;

      const checkGenerateFlagForActive = rows
        .map((row) => row.status)
        .every(isBelowThreshold);
      if (checkGenerateFlagForActive) {
        switch (checkGenerateFlag) {
          case true:
            return "You are about to deactivate an active customer, would you like to proceed?";

          default:
            break;
        }
      } else {
        switch (checkGenerateFlag) {
          case true:
            return "One or more customers you are trying to deactivate are already deactivated, proceed with deactivation?";
          case false:
            return "The customer you are trying to deactivate is already deactivated, proceed with deactivation?";
          default:
            break;
        }
      }
    }
  };

  return (
    <Modal
      open={open.status}
      onClose={() => onClose({ status: false, Type: "" })}
      disableEnforceFocus
      disableAutoFocus
    >
      <Fade in>
        <Box sx={Modalstyle}>
          <Box>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 500,
                lineHeight: "24px",
                color: "#050D2E",
              }}
            >
              {open.Type === "ACTIVE"
                ? "Activate Customers"
                : "Deactivate Customers"}
            </Typography>
          </Box>
          <Typography
            id="modal-un-saved-changes"
            sx={{
              color: "#50566E",
              fontSize: "16px",
              fontWeight: 400,
              margin: "10px 0",
            }}
          >
            {returnWarning()}
          </Typography>
          <Box
            sx={{
              alignSelf: "end",
              flexGrow: 0.5,
              alignItems: "end",
              display: "flex",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1,
              }}
            >
              <CustomButton
                text="Cancel"
                type="secondary"
                processing={false}
                action={() => onClose({ status: false, Type: "" })}
              />
              <CustomButton
                text={
                  open.Type === "ACTIVE"
                    ? "Yes, activate customers"
                    : "Yes, deactivate customers"
                }
                type="update"
                action={() => saveChanges(rows)}
              />
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ActivateCustomers;
